/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpOrganization } from '../models/GcpOrganization';

export class ListGcpOrganizationsResponse {
  /**
  * List of gcp organizations.
  */
  'organizations': Array<GcpOrganization>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "organizations",
      "baseName": "organizations",
      "type": "Array<GcpOrganization>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListGcpOrganizationsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

